import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
	scrollBehavior(_, from) {
		const nuxtApp = useNuxtApp()
		return new Promise((resolve) => {
			nuxtApp.hooks.hookOnce('page:finish', () => {
				if (!from?.name) return resolve(false)

				resolve({
					top: 0,
				})
			})
		})
	},
}
